/* istanbul ignore file */
import styled from 'styled-components';

import { NEUTRAL_050 } from 'styles/tokens';

import Spinner from './Spinner';

export const ImageLoaderContainer = styled.div`
  align-items: center;
  background: ${NEUTRAL_050};
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
`;

const ImageLoader = props => (
  <ImageLoaderContainer {...props}>
    <Spinner />
  </ImageLoaderContainer>
);

export default ImageLoader;
